import { fetch } from '@atlassian/eoc-fetch';
import type { PaginationEndpointParams } from '@atlassian/eoc-pagination';

import type { GlobalEscalationsResponse, ListInfoResponse } from '../../../common/types';

export const getEscalations = ({
	lastEvaluatedToken,
	queryKey,
}: PaginationEndpointParams): Promise<GlobalEscalationsResponse> => {
	const [, filtersString] = queryKey;
	const filters = JSON.parse(filtersString);
	const params = new URLSearchParams({ ...filters, lastEvaluatedToken });

	return fetch<GlobalEscalationsResponse>(`/v1/escalations/search?${params.toString()}`);
};

export const getListInfo = (): Promise<ListInfoResponse> => {
	return fetch<ListInfoResponse>('/v1/escalations/list-info');
};
